var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"drop-down-caret",attrs:{"variant":"link","no-caret":"","dropleft":""},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('ion-icon',{attrs:{"name":"ellipsis-horizontal","size":"small"}})]},proxy:true}])},[_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }